import { useContext } from 'react';
import { Link } from '@tanstack/react-router';

import { Issue } from '@/constants';
import { TrackingContext } from '@/tracking/Tracking.context';
import { MagazineContext } from './Magazine.context';

import styles from './Magazine.module.css';

export const Magazine = ({ issues, isPreview, latest }: MagazineProps) => {
	return (
		<MagazineContext.Provider
			value={{
				issues,
				isPreview: !!isPreview,
			}}
		>
			<section className={styles['magazine']}>
				<LatestIssue issue={latest} />
				<Issues />
			</section>
		</MagazineContext.Provider>
	);
};

interface MagazineProps {
	latest?: Issue;
	issues: Array<Issue>;
	isPreview?: boolean;
}

const LatestIssue = ({ issue }: { issue?: Issue }) => {
	const { isPreview } = useContext(MagazineContext);
	const { sendEvent } = useContext(TrackingContext);
	if (issue?.description) {
		issue.description = ``;
	}

	if (!issue) {
		return <div className={styles['latest-issue']} />;
	}

	const { id, name, cover, description, slug } = issue;
	const url = isPreview ? `/preview/${slug ?? id}` : `/issues/${slug ?? id}`;
	const from = `${window.location.pathname}`;

	return (
		<div className={styles['latest-issue']}>
			<Link
				to={url}
				from={from}
				onClick={() => {
					sendEvent({
						type: 'BTN_CLICK_ISSUE',
						data: {
							issue: {
								id: parseInt(`${id}`, 10),
								slug,
							},
						},
					});
				}}
			>
				<figure role="button" style={{ cursor: 'pointer' }}>
					<img src={cover} alt={`${name} - Cover`} width={340} />
				</figure>
			</Link>
			<div className={styles['title']}>
				<h1>{name}</h1>
				{description ? <p>{description}</p> : null}
				<hr />
			</div>
		</div>
	);
};

interface IssueProps {
	issue: Issue;
}

const Issues = () => {
	const { issues } = useContext(MagazineContext);
	// const newIssues = issues.slice(1);
	return (
		<div className={styles['issues']}>
			<div>
				{issues.map(i => (
					<IssueComponent key={i.id} issue={i} />
				))}
			</div>
		</div>
	);
};

const IssueComponent = ({ issue }: IssueProps) => {
	const { isPreview } = useContext(MagazineContext);
	const { sendEvent } = useContext(TrackingContext);
	if (!issue.description) {
		issue.description = ``;
	}
	const { id, name, description, cover, slug } = issue;

	const url = isPreview ? `/preview/${slug ?? id}` : `/issues/${slug ?? id}`;
	const from = `${window.location.pathname}`;
	return (
		<div className={styles['issue']}>
			<div>
				<Link
					to={url}
					from={from}
					onClick={() => {
						sendEvent({
							type: 'BTN_CLICK_ISSUE',
							data: {
								issue: {
									id: parseInt(`${issue.id}`, 10),
									slug: issue.slug,
								},
							},
						});
					}}
				>
					<figure role="button" style={{ cursor: 'pointer' }}>
						<img src={cover} alt={`${name} - cover`} width={340} />
					</figure>
				</Link>
			</div>
			<div>
				<h4>{name}</h4>
				<p>{description}</p>
			</div>
		</div>
	);
};
